/* @flow */
import * as React from 'react';
import { useIntl } from 'react-intl';

// Utils
import messages from 'src/shared/app/braindate/l10n/braindateL10n';

// Styles
import styles from './LiveTag.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

const useStyles = createUseThemeStyles(styles);

const LiveTag = () => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <div className={classes.root}>{intl.formatMessage(messages.live)}</div>
  );
};

export default React.memo<{}>(LiveTag);
